import type { FC } from 'react';

import { useTranslation } from '@crehana/i18n';
import List from '@crehana/icons/List';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { colors, PrimaryButton } from '@crehana/ui';

interface Step4Props {
  closeDrawer: () => void;
}

const Step4: FC<React.PropsWithChildren<Step4Props>> = ({ closeDrawer }) => {
  const { t } = useTranslation();

  return (
    <section className="flex mb-12 h-full items-center">
      <div className="flex flex-col items-center justify-center">
        <List
          size={48}
          secondaryColor={colors.white}
          color={colors.primaryMain}
        />
        <span className={`font-h4`}>{t('ATTR_STEP_CONFIRM_TITLE')}</span>
        <p className={`font-body3 text-center text-gray-dark mt-12 mb-20`}>
          {t('ATTR_STEP_CONFIRM_DESCRIPTION')}
        </p>
        <div>
          <PrimaryButton
            size="m"
            label={t('ATTR_STEP_CONFIRM_BUTTON')}
            onClick={closeDrawer}
          />
        </div>
      </div>
    </section>
  );
};

export default Step4;
